export function ReportsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.COMPONENTS + '/:action')
        .setCustomActions({
            'search': {
                method: 'GET',
                params: {action: 'license'},
                isArray: true
            },
            'getChildren': {
                method: 'GET',
                params: {action: 'navigator'},
                isArray: true
            },
            'getDetails': {
                method: 'GET',
                params: {action: 'details'}
            },
            'getData': {
                method: 'GET',
                params: {action: 'data'}
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/reports_dao.js